import Button from "../components/Button";
import Card from "../components/Card";
import Steps from "../components/Steps";
import TeamCard from "../components/TeamCard";
import graph from '../assets/graph alone.jpg';
import graphAlone from '../assets/graph.jpg';
import hci from '../assets/HCI.jpg';
import community from '../assets/community.jpg';
import { FaCircle } from "react-icons/fa";
import { FaLightbulb, FaCog, FaRocket, FaUsers } from 'react-icons/fa';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";


function Home() {
  const steps = [
    { title: "Talent Discovery", description: "We identify and nurture young talents across communities." },
    { title: "Skills Development", description: "Through training, mentorship, and education programs, participants gain practical and market-relevant skills." },
    { title: "Community Impact", description: "Participants apply their skills to solve local problems and create economic opportunities." },
    { title: "Sustainable Prosperity", description: "Our initiatives contribute to stronger economies, resilient communities, and ethical leadership." }
  ];

  const team = [
    {
      name: "Jane Doe",
      title: "CEO & Founder",
      quote: "Building solutions that truly make a difference.",
      image: "https://i.pravatar.cc/150?img=1",
    },
    {
      name: "John Smith",
      title: "Lead Developer",
      quote: "Code is poetry when done right.",
      image: "https://i.pravatar.cc/150?img=2",
    },
    {
      name: "Sarah Johnson",
      title: "Product Designer",
      quote: "Design is how it works, not just how it looks.",
      image: "https://i.pravatar.cc/150?img=3",
    },
    {
      name: "David Lee",
      title: "Marketing Lead",
      quote: "Great products deserve great storytelling.",
      image: "https://i.pravatar.cc/150?img=4",
    },
  ];

  const issues = [
    "Youth unemployment",
    "Poverty and inequality",
    "Climate change",
    "Weak governance and leadership"
  ]

  const sdg = [
    "Quality Education",
    "Gender Equality",
    "Decent Work and Economic Growth",
    "Climate Action",
    "Peace, Justice and Strong Institutions"
  ]

  return (
    // hero section
    <>

      <Helmet>
        <title>OGTH – Human Capital Development, Youth Programs & Leadership in Africa</title>
        <meta
          name="description"
          content="OGTH empowers Africa's youth and women through talent discovery, skills development, leadership programs, and community engagement initiatives to drive sustainable economic growth."
        />
        <meta
          name="keywords"
          content="human capital development, youth programs, leadership training, Africa talent programs, skills development, community engagement, education initiatives, OGTH, human capital index"
        />
        <meta property="og:title" content="OGTH – Human Capital Development, Youth Programs & Leadership in Africa" />
        <meta property="og:description" content="OGTH empowers Africa's youth and women through talent discovery, skills development, leadership programs, and community engagement initiatives." />
        <meta property="og:image" content="https://yourdomain.com/path-to-hero-image.jpg" />
        <meta property="og:url" content="https://yourdomain.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className="bg-gradient-to-b from-brand to-[#1A3A6F] text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

          {/* Left side - Text */}
          <div className="space-y-6">
            <h1 className="text-3xl font-bold">Unlocking Africa's Human Capital for a Prosperous Future</h1>
            <p className="font-bold text-gray-300">The Organization for Global Talents Hunt (OGTH)</p>
            <p className="pb-5 text-justify"> is a
              non-governmental organization under the Project Africa
              framework dedicated to discovering, developing, and
              deploying the talents of Africa's youth and women.
              Through innovative programs and strategic partnerships,
              we empower individuals with the skills and leadership
              capacity needed to build resilient communities and
              drive sustainable economic prosperity across Africa.</p>
            <NavLink to="/program">
              <Button variant="secondary">Join Our Programs</Button>
            </NavLink>
          </div>

          {/* Right side - Image */}
          <div className="flex justify-center md:justify-end">
            <img
              src={community} // Replace with image path
              alt="Hero Illustration"
              className="w-full max-w-lg rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>
      {/* Hero section ends here */}

      {/*  Human capital index section */}
      <section className="bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

          {/* Left side - Image */}
          <div className="flex justify-center md:justify-end">
            <img
              src={graph}
              alt="HCI Illustration"
              className="w-full max-w-lg rounded-lg shadow-lg"
            />
          </div>

          {/* Right side - Text */}
          <div className="space-y-6">
            <h1 className="text-xl text-center font-bold">Why Human Capital Matters</h1>
            <p className="text-justify">According to the World Bank's Human Capital Index, children born in Sub-Saharan Africa today will only realize about 40% of their productive potential due to gaps in education, health, and skills development.
              <br /><br /> At OGTH, we believe Africa's future prosperity depends on investing in human capital.
              Our initiatives contribute to the Africa Human Capital Vision 2050, a long-term roadmap aimed at increasing Africa's Human Capital Index to 0.8 by the year 2050.
              <br /><br /> By investing in talent discovery, education, skills development, and ethical leadership, we empower individuals to become drivers of sustainable development and economic transformation.
            </p>
          </div>
        </div>
      </section>
      {/* Human capital index section ends here */}

      {/* about us section */}
      <section className="bg-brand">
        <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

          {/* Left side - Text */}
          <div className="space-y-6 text-white r">
            <h1 className="text-lg font-bold">Who We Are</h1>
            <p className="font-bold text-gray-300 text-jsutify">The Organization for Global Talents Hunt (OGTH) is a registered non-governmental organization with Nigeria's Corporate Affairs Commission.</p>
            <p className="pb-5 text-jsutify">Headquartered in Nigeria, OGTH works across Africa to empower young people and women who represent nearly 70% of Nigeria's population.
              <br /> Our mission is to discover hidden talents, develop them into practical skills, and deploy them as solution providers addressing Africa's most pressing challenges including:
              <br />
              <ul className="space-y-4 max-w-md my-5 ">
                {issues.map((issue, index) => (
                  <li
                    key={index}
                    className="flex items-center gap-3 bg-brand-secondary text-white rounded-lg px-4 py-3 shadow-sm hover:shadow-md hover:-translate-y-1 transition"
                  >
                    {/* Circle */}
                    <span className="flex items-center justify-center w-6 h-6 rounded-full border-2 border-white">
                      <FaCircle className="text-[6px] text-white" />
                    </span>

                    {/* Text */}
                    <span className="font-medium">
                      {issue}
                    </span>
                  </li>
                ))}
              </ul>

              Through structured programs and innovative platforms, we equip individuals with the tools to build better communities and stronger economies.
            </p>
            <NavLink to='/about' >
              <Button variant="secondary" >Learn more</Button>
            </NavLink>
          </div>

          {/* Right side - Image */}
          <div className="flex justify-center md:justify-end">
            <img
              src={graphAlone} // Replace with image path
              alt="Hero Illustration"
              className="w-full max-w-lg rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>
      {/* about us section ends here */}

      {/* Student's journey section */}
      <section className="bg-gray-50 py-20 px-6">
        <div className="text-center">
          <h1 className="text-lg font-bold">The OGTH Talent Journey</h1>
          <p className="font-bold text-brand-greenText">At OGTH we guide individuals through a transformational journey built around our 3D Human Capital Model.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 p-6 px-16">
          <Card
            icon={<FaLightbulb />}
            title="Discovery"
            body="Identify your natural talents, passions, and abilities through assessments, mentorship, and exposure."
            footer="Read More"
          />

          <Card
            icon={<FaCog />}
            title="Development"
            body="Transform discovered talents into practical skills through education, training, and real-world learning opportunities."
            footer="Learn More"
          />

          <Card
            icon={<FaRocket />}
            title="Deployment"
            body="Apply your skills to solve real societal challenges and contribute to economic development."
            footer="Read more"
          />

          <Card
            icon={<FaUsers />}
            title="Leadership"
            body="Become a responsible leader who drives innovation, ethical governance, and community impact."
          // footer="Contact Us"
          />
        </div>
      </section>
      {/* Student's journey section ends here */}

      {/* quiz section */}
      <section className="bg-gray-50 px-5 pb-20">
        <div className="bg-gradient-to-r from-brand to-brand-secondary w-[90%] w-md-[350px] mx-auto my-auto rounded-xl shadow-sm text-white flex flex-col items-center p-2">
          <h1 className="font-semibold">Discover Your Talent Potential</h1>
          <p className="p-2">Take our Talent Discovery Quiz to explore your strengths and learn how you can develop them into impactful skills.</p>
          <Button variant="secondary">
            <Link to="/quiz">Start the quiz</Link>
          </Button>
        </div>
      </section>
      {/* quiz section ends here */}
    </>

  )
}

export default Home;